import React from 'react';
// import AppProvider from "../../../Components/bootstrap"
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles(theme => ({
    "@global": {
      body: {
        backgroundColor: "#F7F7F7",
      }
    },
    Avatar:{
        height:"35px"
    }
}));
export default function MentorProfile(handleSubmit,
    reset,
    submitting,
    pristine,
    values,  
    props,
    ...rest) {
    const classes = useStyles();

    var  card = [
        {title : "Recent Feedback",
        reting : "User Rating: 4/5",
        subtext1 : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit",
        reting1 : "User Rating: 4/5",
        subtext2 : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit"

    },]
  

    return (
        <div className={classes.div}>
            <div >
                <form onSubmit={handleSubmit} noValidate>
                {/* <Typography >Home/Mentor Profile</Typography> */}
                {card.map(card=>(
                <Paper style={{boxShadow:"none",}}>
                    <Typography varinat="h6" style={{marginTop:"40px",fontWeight:"500"}}>{card.title}</Typography>
                        <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>
                            {card.renting}
                        </Typography>
                        <Typography variant="body2" style={{opacity:"0.7"}}>
                            {card.subtext1}
                        </Typography><br/>
                        <Divider light style={{width:"200px",margin:"auto",border:"0.5px rgba(179, 172, 172, 0.7) solid"}}/>
                        <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>
                        {card.renting1}
                        </Typography>
                        <Typography variant="body2" style={{opacity:"0.7"}}>
                        {card.subtext2}
                        </Typography>
                     <Divider light style={{width:"200px",margin:"auto",border:"0.5px rgba(179, 172, 172, 0.7) solid",marginTop:"20px"}}/>
                </Paper>
                ))}
               </form>
            </div>

         </div>
    );
}
